import getClassesAndStudentsApiCall from '../../../apiCalls/ngs/getClassesAndStudents';

function* getClassesAndStudents(orgId) {
  yield getClassesAndStudentsApiCall(orgId);
}

export default getClassesAndStudents;
